import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(date) {
  if (!date) return '';
  const d = new Date(date);
  return d.toLocaleDateString('sv-SE');
}

export function formatDateTime(date) {
  if (!date) return '';
  const d = new Date(date);
  return d.toLocaleString('sv-SE');
}

export function calculateProgress(current, target) {
  if (!target || target === 0) return 0;
  return Math.min(Math.round((current / target) * 100), 100);
}
